var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParagraph2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "#464646",
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.923 17V7.9H9.108C9.81867 7.9 10.408 8.02133 10.876 8.264C11.344 8.498 11.6907 8.823 11.916 9.239C12.15 9.64633 12.267 10.11 12.267 10.63C12.267 11.124 12.1543 11.579 11.929 11.995C11.7123 12.4023 11.37 12.7273 10.902 12.97C10.434 13.2127 9.836 13.334 9.108 13.334H7.301V17H5.923ZM7.301 12.203H9.043C9.693 12.203 10.1567 12.0643 10.434 11.787C10.72 11.501 10.863 11.1153 10.863 10.63C10.863 10.1273 10.72 9.73733 10.434 9.46C10.1567 9.174 9.693 9.031 9.043 9.031H7.301V12.203ZM13.4471 17V16.012C14.0364 15.544 14.5997 15.0717 15.1371 14.595C15.6744 14.1183 16.1511 13.6503 16.5671 13.191C16.9917 12.723 17.3254 12.268 17.5681 11.826C17.8107 11.3753 17.9321 10.942 17.9321 10.526C17.9321 10.2487 17.8844 9.98867 17.7891 9.746C17.6937 9.49467 17.5377 9.29533 17.3211 9.148C17.1044 8.992 16.8141 8.914 16.4501 8.914C15.9041 8.914 15.4924 9.08733 15.2151 9.434C14.9464 9.78067 14.8164 10.1967 14.8251 10.682H13.4861C13.4947 10.0407 13.6291 9.50333 13.8891 9.07C14.1577 8.63667 14.5131 8.30733 14.9551 8.082C15.4057 7.85667 15.9127 7.744 16.4761 7.744C17.3341 7.744 18.0187 7.98667 18.5301 8.472C19.0501 8.94867 19.3101 9.616 19.3101 10.474C19.3101 10.9853 19.1844 11.4923 18.9331 11.995C18.6904 12.4977 18.3697 12.983 17.9711 13.451C17.5811 13.9103 17.1607 14.3437 16.7101 14.751C16.2594 15.1583 15.8304 15.5267 15.4231 15.856H19.5831V17H13.4471Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParagraph2);
export default __webpack_public_path__ + "static/media/paragraph_2.4b96fab5949bc21279dfef7bc6b43d7a.svg";
export { ForwardRef as ReactComponent };